import HorizontalDividers from 'components/CustomDividers/HorizontalDividers';
import VerticalDividers from 'components/CustomDividers/VerticalDividers';
import { DialogContentStyled, Label, LeftContentWrapper, RightContentWrapper } from 'components/Dialog/DialogContent';
import { Container, Guide } from 'components/Dialog/DialogLeftContent';
import { Bottom, BottomActions, ConnectButton, RightForm } from 'components/Dialog/DialogRightContent';
import { ErrorMessage, Input, InputGrid } from 'components/Form';
import WarningIcon from '@mui/icons-material/Warning';
import React, { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { getFacebookAuthorizeUrl } from 'api/marketPlaces';
import { showAlert } from 'components/Alert';
import { useAppStore } from 'stores/appStore';
import ButtonReauthorization from 'pages/Onboarding/StepTwo/ButtonReauthorization';
import ButtonAuthorization from 'pages/Onboarding/StepTwo/ButtonAuthorization';

interface FormValues {
  business_manager_id: string;
  app_id: string;
  app_secret: string;
}

interface FacebookConnectProps {
  chData?: {
    extra_info: {
      business_id: string;
      app_id: string;
      app_secret: string
    }
  };
  isConnected?: boolean;
}

const FacebookContent: React.FunctionComponent<FacebookConnectProps> = ({ chData, isConnected = false }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm<FormValues>();
  const { indexAccordion, disablePrevButton } = useAppStore();

  const onSubmit: SubmitHandler<FormValues> = async (value) => {
    try {
      const res: any = await getFacebookAuthorizeUrl({
        business_id: value.business_manager_id,
        app_id: value.app_id,
        app_secret: value.app_secret
      }, indexAccordion, disablePrevButton);
      if (res && res?.data && res?.data?.status == 'ok') {
        window.location.href = res?.data?.redirect;
      } else {
        showAlert('error', `${res?.data?.message}`, 5000);
      }
    } catch (err) {
      const error = err as Error;
      showAlert('error', `${error}`, 5000);
    }
  };

  useEffect(() => {
    if (isConnected && chData?.extra_info?.business_id) {
      // Set the business manager ID from the connected data
      setValue('business_manager_id', chData.extra_info.business_id);
      setValue('app_id', chData.extra_info.app_id);
      setValue('app_secret', chData.extra_info.app_secret);
    }
  }, [isConnected, chData, setValue]);

  return (
    <DialogContentStyled>
      <LeftContentWrapper>
        <Container>
          <h3>Sambungkan Toko</h3>
          <p>
          Anda memerlukan Akun Pengelola Bisnis dan Katalog di Facebook. Bila Anda belum mempunyai Akun Pengelola
          Bisnis ataupun Katalog, mohon membuatnya terlebih dahulu dengan mengikuti panduan berikut:
          </p>
          <a
            href="https://www.facebook.com/business/help/1710077379203657"
            style={{ color: 'blue', cursor: 'pointer' }}
          >Panduan Membuat Pengelola Bisnis</a>
          <a
            href="https://www.facebook.com/business/help/1397294963910848"
            style={{ color: 'blue', cursor: 'pointer' }}
          >Panduan Membuat Katalog
          </a><br />
          <p>Untuk jenis Katalog, pilih Produk.</p>
        </Container>
        <Guide 
          href="https://education.jubelio.com/classes/course/integrasi-social-commerce?menu=integrasi-facebook-shop-ke-jubelio"
          target="_blank"
        >Panduan Menemukan ID Pengelola Bisnis</Guide>
      </LeftContentWrapper>
      <VerticalDividers />
      <RightContentWrapper>
        <RightForm id="facebook_form" onSubmit={handleSubmit(onSubmit)}>
          <InputGrid
            label={<Label className="requiredField">ID Pengelola Bisnis</Label>}
            input={
              <Input
                isError={errors.business_manager_id?.message ? true : false}
                type={'text'}
                placeholder={''}
                disabled={isConnected}
                {...register('business_manager_id', {
                  required: { value: true, message: 'ID Pengelola Bisnis harus di isi' }
                })}
              />
            }
            errorMessage={
              errors?.business_manager_id && (
                <ErrorMessage
                  icon={<WarningIcon fontSize="small" color="error" />}
                  message={errors.business_manager_id.message}
                />
              )
            }
            wide={true}
          />
          <InputGrid
            label={<Label className="requiredField">App ID</Label>}
            input={
              <Input
                isError={errors.app_id?.message ? true : false}
                type={'text'}
                placeholder={''}
                disabled={isConnected}
                {...register('app_id', {
                  required: { value: true, message: 'App ID harus di isi' }
                })}
              />
            }
            errorMessage={
              errors?.app_id && (
                <ErrorMessage
                  icon={<WarningIcon fontSize="small" color="error" />}
                  message={errors.app_id.message}
                />
              )
            }
            wide={true}
          />
          <InputGrid
            label={<Label className="requiredField">App Secret</Label>}
            input={
              <Input
                isError={errors.app_secret?.message ? true : false}
                type={'text'}
                placeholder={''}
                disabled={isConnected}
                {...register('app_secret', {
                  required: { value: true, message: 'App Secret harus di isi' }
                })}
              />
            }
            errorMessage={
              errors?.app_secret && (
                <ErrorMessage
                  icon={<WarningIcon fontSize="small" color="error" />}
                  message={errors.app_secret.message}
                />
              )
            }
            wide={true}
          />
        </RightForm>
        <Bottom>
          <HorizontalDividers />
          <BottomActions>
            <ButtonReauthorization {...{
              isConnected,
              form: 'facebook_form'
            }} />
            <ButtonAuthorization {...{
              form: 'facebook_form',
              disable: isConnected
            }} />
          </BottomActions>
        </Bottom>
      </RightContentWrapper>
    </DialogContentStyled>
  );
};

export default FacebookContent;
